import * as React from 'react';

export const useFocusControl = () => {
  const [ clickFocus, setClickFocus ] = React.useState(false);
  const stopClickFocus = () => setClickFocus(true);
  const resetClickFocus = () => setClickFocus(false);

  return {
    clickFocus,
    stopClickFocus,
    resetClickFocus,
  };
};
